module.exports = __webpack_public_path__ + "static/media/31.9814cca7.jpg";